export const gas_types = [
  "АИ-92",
  "А-80",
  "Евро Аи-92",
  "АИ-95",
  "АИ-98",
  "ДТ",
  "Евро-ДТ",
  "Авто хий",
];

export const demo_stations = [
  {
    name: "Хан-уул ШТС",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
    available_gases: [gas_types[0], gas_types[1], gas_types[2]],
    lat: 47.91894927229234,
    lng: 106.91759660338,
    additionalServices: ["Бөөний хошуутай", "Дэлгүүр", "Тос / Аккумулятор"],
  },
  {
    name: "ШТС-2",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
    available_gases: [gas_types[3], gas_types[0], gas_types[1]],
    lat: 47.92077345250782,
    lng: 106.88408996936121,
    additionalServices: ["Бөөний хошуутай", "Дэлгүүр", "Тос / Аккумулятор"],
  },
  {
    name: "Төв ШТС",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
    available_gases: [gas_types[5], gas_types[6], [gas_types[2]]],
    lat: 47.92805661871708,
    lng: 106.89138245340887,
    additionalServices: ["Бөөний хошуутай", "Дэлгүүр", "Тос / Аккумулятор"],
  },
  {
    name: "Хан-уул ШТС",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
    available_gases: gas_types,
    lat: 47.90352470577841,
    lng: 106.9124184650848,
    additionalServices: ["Бөөний хошуутай", "Дэлгүүр", "Тос / Аккумулятор"],
  },
  {
    name: "Зунжин ШТС",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
    available_gases: gas_types,
    lat: 47.92345189736256,
    lng: 106.86705079990372,
    additionalServices: ["Бөөний хошуутай", "Дэлгүүр", "Тос / Аккумулятор"],
  },
  {
    name: "Жигжид ШТС",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
    available_gases: gas_types,
    lat: 47.90963527364157,
    lng: 106.95280760750258,
    additionalServices: ["Бөөний хошуутай", "Дэлгүүр", "Тос / Аккумулятор"],
  },
];

export const faq_data = [
  {
    title: "Нэвтрэх нууц кодоо мартсан тохиолдолд хэрхэн сэргээх вэ?",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
  {
    title: "Картын мэдээллээ солих боломжтой юу?",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
  {
    title: "Хэрхэн карт захиалга хийх вэ?",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
  {
    title: "Картын төлөв хаагдсан тохиолдолд ямар арга хэмжээ авах вэ?",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
  {
    title: "Тайлан хэсэг-рүү хэрхэн файл оруулах вэ?",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
];
